"use client";

interface Props {
  agentName?: string;
  agentColor?: string;
}

const AGENT_LABELS: Record<string, string> = {
  curator: "Curator",
  coach: "Coach",
  planner: "Planner",
  analyst: "Analyst",
  companion: "Companion",
};

const AGENT_INITIALS: Record<string, string> = {
  curator: "C",
  coach: "K",
  planner: "P",
  analyst: "A",
  companion: "V",
};

export default function AgentTyping({ agentName, agentColor }: Props) {
  const label = agentName ? AGENT_LABELS[agentName] || "DE" : "DecisionEase";
  const initial = agentName ? AGENT_INITIALS[agentName] || "DE" : "DE";
  const color = agentColor || "#3E5E3A";

  return (
    <div className="flex items-center gap-2 mb-3">
      <div
        className="w-5 h-5 rounded-full flex items-center justify-center"
        style={{ backgroundColor: color }}
      >
        <span className="text-[9px] text-white font-bold">{initial}</span>
      </div>
      <span className="text-[11px] text-muted">{label} is thinking</span>
      <div className="flex gap-1">
        <span
          className="w-1.5 h-1.5 rounded-full animate-bounce"
          style={{ backgroundColor: color, opacity: 0.5, animationDelay: "0ms" }}
        />
        <span
          className="w-1.5 h-1.5 rounded-full animate-bounce"
          style={{ backgroundColor: color, opacity: 0.5, animationDelay: "150ms" }}
        />
        <span
          className="w-1.5 h-1.5 rounded-full animate-bounce"
          style={{ backgroundColor: color, opacity: 0.5, animationDelay: "300ms" }}
        />
      </div>
    </div>
  );
}
